// Цвета графиков статистики логина.
// Устройство = оттенок (web — индиго, mobile — зелёный, crm — фиолетовый, ...).
// Внутри стека два СПЛОШНЫХ сегмента: насыщенный (низ) и светлый (верх) оттенок
// устройства. «Заблокировано» — всегда красный (сигнал), независимо от устройства.

export const DEVICE_LABELS = {
  web: 'web',
  mobile: 'mobile',
  crm: 'crm',
  aggregator: 'агрегатор',
  unknown: 'прочие',
}

const DEVICE_COLORS = {
  web: '#3D00FE',
  mobile: '#00A86B',
  crm: '#9C27B0',
  aggregator: '#FB8C00',
  unknown: '#607D8B',
}

const DEVICE_FALLBACK = ['#3D00FE', '#00A86B', '#9C27B0', '#FB8C00', '#EC407A', '#607D8B']

const RED = '#E53935'

const BREAKDOWN_COLORS = {
  sent: '#FF9100',
  login: '#43A047',
  blocked: RED,
}

export function deviceColor (device, i = 0) {
  return DEVICE_COLORS[device] || DEVICE_FALLBACK[i % DEVICE_FALLBACK.length]
}

// Светлый СПЛОШНОЙ оттенок (подмешиваем белый), без прозрачности.
function lighten (hex, ratio) {
  const h = hex.replace('#', '')
  const r = Math.round(parseInt(h.slice(0, 2), 16) * (1 - ratio) + 255 * ratio)
  const g = Math.round(parseInt(h.slice(2, 4), 16) * (1 - ratio) + 255 * ratio)
  const b = Math.round(parseInt(h.slice(4, 6), 16) * (1 - ratio) + 255 * ratio)
  return `rgb(${r}, ${g}, ${b})`
}

function deviceLabel (device) {
  return DEVICE_LABELS[device] || device
}

export function uniqueLabels (rows) {
  return [...new Set(rows.map((r) => r.date))].sort()
}

export function presentDevices (rows) {
  return [...new Set(rows.map((r) => r.deviceType))]
}

function pick (rows, device, field) {
  const byKey = {}
  rows.forEach((r) => {
    if (r.deviceType === device) byKey[r.date] = r
  })
  return (labels) => labels.map((d) => (byKey[d] ? byKey[d][field] : 0))
}

function dataset (label, data, color, stack) {
  return { label, data, backgroundColor: color, stack }
}

export function buildHeroDatasets (rows, labels) {
  const datasets = []
  presentDevices(rows).forEach((device, i) => {
    const color = deviceColor(device, i)
    const logins = pick(rows, device, 'loginsCount')(labels)
    const sent = pick(rows, device, 'codesSent')(labels)
    const noLogin = sent.map((v, idx) => Math.max(v - logins[idx], 0))
    // Низ стека темнее верха: логины (низ) — насыщенный, без логина (верх) — светлый.
    datasets.push(dataset(`${deviceLabel(device)} · логины`, logins, color, device))
    datasets.push(dataset(`${deviceLabel(device)} · без логина`, noLogin, lighten(color, 0.5), device))
  })
  return datasets
}

export function buildLoadDatasets (rows, labels) {
  const datasets = []
  presentDevices(rows).forEach((device, i) => {
    const color = deviceColor(device, i)
    datasets.push(dataset(`${deviceLabel(device)} · отправлено`, pick(rows, device, 'codesSent')(labels), color, device))
    datasets.push(dataset(`${deviceLabel(device)} · заблокировано`, pick(rows, device, 'blockedCount')(labels), RED, device))
  })
  return datasets
}

export function buildChannelsDatasets (rows, labels) {
  const datasets = []
  presentDevices(rows).forEach((device, i) => {
    const color = deviceColor(device, i)
    // Низ стека темнее верха: flash (низ) — насыщенный, SMS (верх) — светлый.
    datasets.push(dataset(`${deviceLabel(device)} · flash`, pick(rows, device, 'flashCount')(labels), color, device))
    datasets.push(dataset(`${deviceLabel(device)} · SMS`, pick(rows, device, 'smsCount')(labels), lighten(color, 0.5), device))
  })
  return datasets
}

export function buildRateDatasets (rows, labels) {
  return presentDevices(rows).map((device, i) => {
    const color = deviceColor(device, i)
    return {
      label: deviceLabel(device),
      data: pick(rows, device, 'loginRate')(labels),
      borderColor: color,
      backgroundColor: color,
      spanGaps: true,
      tension: 0.3,
      pointRadius: 2,
    }
  })
}

export function buildDeviceBreakdown (rows) {
  const devices = presentDevices(rows)
  const sum = (device, field) =>
    rows.filter((r) => r.deviceType === device).reduce((acc, r) => acc + (r[field] || 0), 0)
  const ds = (label, field, color) => ({
    label,
    data: devices.map((d) => sum(d, field)),
    backgroundColor: color,
  })
  return {
    labels: devices.map((d) => DEVICE_LABELS[d] || d),
    datasets: [
      ds('Отправлено', 'codesSent', BREAKDOWN_COLORS.sent),
      ds('Логины', 'loginsCount', BREAKDOWN_COLORS.login),
      ds('Заблокировано', 'blockedCount', BREAKDOWN_COLORS.blocked),
    ],
  }
}
